// gav2_guide-section.js
document.addEventListener('DOMContentLoaded', function() {
  // Find any accordion containers by data attribute
  const accordions = document.querySelectorAll('[data-gav2-accordion]');

  accordions.forEach(accordion => {
    // Get all the accordion items inside this container
    const accordionItems = accordion.querySelectorAll('.gav2-accordion__item');

    accordionItems.forEach(item => {
      const title = item.querySelector('.gav2-accordion__title');
      if (title) {
        title.addEventListener('click', function() {
          // Remove 'active' class from all items within this accordion container
          accordionItems.forEach(i => {
            if (i !== item) {
              i.classList.remove('active');
            }
          });
          // Toggle the active class on this item
          item.classList.toggle('active');
        });
      }
    });
  });
});




